<template>
  <div class="modal fade" id="viewAllBills" tabindex="-1" aria-hidden="true">
    <div class="modal-dialog modal-xl" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <div class="container-fluid">
            <div class="row">
              <div class="col-9 col-sm-5 col-lg-5 my-auto">
                <h5 class="modal-title" id="viewAllBillsLabel">View All Bills</h5>
              </div>
              <div class="col-3 col-sm-7 my-auto">
                <div>
                  <div>
                    <span>
                      <a class="close">
                        <i
                          class="far fa-times-circle fa-2x"
                          data-dismiss="modal"
                          id="closeAllBills"
                          aria-label="Close"
                        ></i>
                      </a>
                    </span>
                  </div>
                  <div>
                    <!-- <router-link :to="{ path: '/dashboard'}" target="_blank">
                      <span class="fa-stack fa-2x fsm float-right">
                        <i class="far fa-circle fa-stack-2x"></i>
                        <i class="fas fa-external-link-alt fa-stack-1x"></i>
                      </span>
                    </router-link>-->
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="modal-body">
          <div class="container-fluid">
            <div class="row">
              <div class="col-xl-12">
                <div id="vb_accordion" class="accordion border border-light rounded">
                  <div class="card mb-0">
                    <div class="card-header collapsed col-sm-12" data-toggle="collapse">
                      <div class="row">
                        <div class="col-sm-4">
                          <p>View Bills</p>
                        </div>
                        <!-- <div class="col-sm-4">
                          <div class="search_75">
                            <form class="input-group md-form form-sm">
                              <input class="form-control form-control-sm search" name="search" placeholder="Search"
                                autocomplete="off" type="text">
                              <div class="input-group-btn">
                                <a href="#" role="button"><i class="fa fa-search active" aria-hidden="true"></i></a>
                              </div>
                            </form>
                          </div>
                        </div>
                        <div class="col-xs-12 col-sm-4 mobile-space-t">
                          <button type="button" data-toggle="collapse" data-target=".sh_search" class="more btn btn-hc-nb float-right"></button>
                        </div>-->
                      </div>

                      <div class="sh_search collapse show mt-3">
                        <div class="row">
                          <div class="col-12 col-sm-6">
                            <div class="row">
                              <div class="col-sm-6">
                                <a
                                  @click="last30Days"
                                  role="button"
                                  class="btn btn-hc-outline btn-block no-pad"
                                >
                                  Last 30
                                  days
                                </a>
                              </div>
                              <div class="col-sm-6">
                                <a
                                  @click="last6Months"
                                  role="button"
                                  class="btn btn-hc-outline btn-block no-pad"
                                >
                                  Last 6
                                  months
                                </a>
                              </div>
                            </div>
                            <div class="row">
                              <div class="col-sm-6 mt-2">
                                <a
                                  @click="last12Months"
                                  role="button"
                                  class="btn btn-hc-outline btn-block no-pad"
                                >
                                  Last
                                  12 months
                                </a>
                              </div>
                              <div class="col-sm-6 mt-2">
                                <a
                                  @click="clearFilter"
                                  role="button"
                                  class="btn btn-hc-outline btn-block no-pad"
                                >
                                  Clear
                                  filters
                                </a>
                              </div>
                            </div>
                          </div>
                          <div class="col-12 col-sm-6">
                            <div class="row">
                              <div class="col-sm-12">
                                <el-date-picker
                                  v-model="startDate"
                                  format="dd.MM.yyyy"
                                  type="date"
                                  placeholder="Select a start date"
                                ></el-date-picker>
                              </div>
                              <div class="col-sm-12">
                                <el-date-picker
                                  class="my-2"
                                  v-model="endDate"
                                  format="dd.MM.yyyy"
                                  type="date"
                                  placeholder="Select an end date"
                                ></el-date-picker>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-sm-12">
                    <div class="row">
                      <div class="table-div col-12 mt-3 pl-3 pr-3">
                        <b-table
                          id="allBills"
                          class="bills-table table-scroll tbl-sml"
                          striped
                          hover
                          :items="filteredBills"
                          :fields="billFields"
                          :tbody-tr-class="item => this.selectedbills.includes(item) ? 'selected' :''"
                          @row-clicked="selectRange"
                        >
                          <template
                            slot="PeriodEnds"
                            slot-scope="data"
                          >{{data.item.PeriodEnds | shortDate}}</template>
                          <template
                            slot="NewCharges"
                            slot-scope="data"
                          >{{data.item.NewCharges.Amount | currency}}</template>
                          <template
                            slot="PeriodStarts"
                            slot-scope="data"
                          >{{data.item.PeriodStarts | shortDate}}</template>
                          <template
                            slot="TaxPoint"
                            slot-scope="data"
                            v-if="data.item.TaxPoint"
                          >{{data.item.TaxPoint | shortDate}}</template>
                          <template slot="Status" slot-scope="row">
                            <!-- This is the status such as draft, on hold or billed -->
                            {{wordSplit(row.item.Status)}}
                            <i
                              v-if="row.item.Status == 'OnHold'"
                              @click="toggleRow(row)"
                              class="fas fa-info-circle pointer"
                            ></i>
                          </template>

                          <template slot="row-details" slot-scope="row">
                            <b-card>
                              <div class="row">
                                <div class="col-12">
                                  <div class="row">
                                    <div class="col-4">
                                      <p class="font-weight-bold">Reasons(s):</p>
                                    </div>
                                    <div class="col-8">
                                      <div class="ta-group">
                                        <b-textarea
                                          v-model="row.item.StatusNarrative"
                                          class="form-control bills-reason-fc z-depth-1"
                                          rows="3"
                                          :disabled="!editMode"
                                          :maxlength="500"
                                        ></b-textarea>
                                        <div class="text-right small text-muted mt-1">
                                          {{ (row.item.StatusNarrative || '').length }}/500
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>

                              <hr class="mt-2" />
                              <div class="text-right mt-2" v-if="!editMode">
                                <b-btn
                                  @click="toggleEditMode(true, row)"
                                  class="btn btn-hc btn-sm"
                                >
                                  Edit
                                </b-btn>
                              </div>
                              <div class="row" v-if="editMode">
                                <div class="col-12">
                                  <div>
                                    <div class="text-left float-right">
                                      <b-btn
                                        @click="toggleEditMode(false, row)"
                                        class="btn btn-hc mr-1"
                                        :disabled="submitStatus == 'PENDING'"
                                      >Cancel</b-btn>
                                      <b-btn
                                        @click="saveChanges(row.item)"
                                        class="btn btn-hc ml-1"
                                        :disabled="submitStatus == 'PENDING'"
                                      >
                                        Save
                                        Changes
                                      </b-btn>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </b-card>
                          </template>

                          <template slot="SalesTransaction" slot-scope="data">
                            <a @click="viewStatement(data.item.SalesTransaction.DocumentUri)">
                              <h5
                                class="font-weight-bold d-inline position-absolute"
                              >{{data.item.StatementNumber}}</h5>
                              <img
                                src="@/assets/img/download_icon.png"
                                class="d-inline"
                                alt="Download a bill"
                              />
                            </a>
                          </template>
                          <template slot="Action" slot-scope="data">
                            <!-- The action is dependant on the status -->
                            <!-- If draft need to be able to commit, delete or hold. If on hold release and if billed you can cancel -->
                            <div v-if="notCancelled.length != 0">
                              <div
                                v-if="data.item.StatementNumber == notCancelled[notCancelled.length - 1].StatementNumber"
                              >
                                <a
                                  v-if="data.item.Status == 'Committed'"
                                  href="#"
                                  class="bb link"
                                  data-toggle="modal"
                                  data-target="#Cancel"
                                  @click="rowClicked(data.item)"
                                >
                                  Cancel
                                  <br />
                                </a>
                              </div>
                            </div>
                            <a
                              v-if="showCommitOption(data.item)"
                              href="#"
                              class="bb link"
                              data-toggle="modal"
                              data-target="#Commit"
                              @click="rowClicked(data.item)"
                            >
                              Commit
                              <br />
                            </a>
                            <a
                              v-if="showDeleteOption(data.item)"
                              href="#"
                              class="bb link"
                              data-toggle="modal"
                              data-target="#Delete"
                              @click="rowClicked(data.item)"
                            >
                              Delete
                              <br />
                            </a>
                            <a
                              v-if="showHoldOption(data.item)"
                              href="#"
                              class="bb link"
                              data-toggle="modal"
                              data-target="#Hold"
                              @click="rowClicked(data.item)"
                            >Hold</a>
                            <a
                              v-if="showReleaseOption(data.item)"
                              href="#"
                              class="bb link"
                              data-toggle="modal"
                              @click="release(data.item)"
                            >
                              Release
                              <br />
                            </a>
                          </template>
                        </b-table>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="d-flex justify-content-end align-items-center">
                  <span class="px-3"> {{ selectedbills.length }} Bills Selected</span>
                  <button type="button" class="btn btn-danger" :disabled="selectedbills.length == 0" @click="bulkDelete"
                  data-toggle="modal"
                  data-target="#BillBulkDelete">Bulk Delete</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment';
import Vue from 'vue';
import _filters from '@/mixins/filters.js';
import billOptions from '@/mixins/billOptions.js';

export default {
  mixins: [_filters, billOptions],
  data() {
    return {
      selected: null,
      selectedRange: null,
      startDate: '',
      endDate: '',
      activeService: {
        serial: 0,
      },
      billFields: {
        PeriodEnds: {
          label: 'Period To',
          sortable: true,
          class: 'text-center col-2',
        },
        NewCharges: {
          label: 'Total Value',
          class: 'text-center col-1',
        },
        PeriodStarts: {
          label: 'Period From',
          class: 'text-center col-2',
        },
        TaxPoint: {
          label: 'Tax Point',
          class: 'text-center col-2',
        },
        Status: {
          label: 'Status',
          class: 'text-center col-2',
        },
        SalesTransaction: {
          label: 'View',
          class: 'text-center col-1',
        },
        Action: {
          label: 'Action',
          class: 'text-center col-2',
        },
      },
    };
  },
  computed: {
    filteredBills: function() {
      if (!this.startDate || !this.endDate) {
        return this.orderedBills;
      }
      var that = this;
      return this.$_.filter(this.orderedBills, function(bill) {
        return (
          moment(bill.PeriodEnds).isSameOrAfter(that.startDate) &&
          moment(bill.PeriodEnds).isSameOrBefore(that.endDate)
        );
      });
    },

    selectedbills() {
      if (!this.orderedBills || !this.selectedRange) return [];

      return this.orderedBills.filter(
        (b) =>
          b.PeriodEnds > this.selectedRange.PeriodStarts &&
          !(b.IsCancelled || b.IsDeleted)
      );
    },
  },

  mounted() {
    $('#viewAllBills').on('show.bs.modal', () => {
      this.selected = null;
      this.selectedRange = null;
    });
  },

  methods: {
    viewStatement(documentUri) {
      
      const urlParts = documentUri.split('/');
      const documentType = urlParts[urlParts.length - 3]; // 'statements' or 'invoices'
      // Extract the invoice/statement ID from the DocumentUri on the SalesTransaction
      const documentId = urlParts[urlParts.length - 2];

      this.$http
      .get(
          "https://" +
          this.$config.honeycomb.billbotstatements.domain +
          "/api/v1/" +
          documentType + "/" +
          documentId +
          "/uri",
          { withCredentials: true }
      )
        .then((response) => {
          const finalUrl = response.data.url;
          window.open(finalUrl, "_blank");
        }
        )
        .catch((error) => {
          if (error.response) {
            this.$snotify.error(
              `Error viewing invoice: ${(error.response.data && error.response.data.UserDescription) || error.response.statusText}`,
              {
                timeout: 0,
                closeOnClick: true,
              }
            );
          } else if (error.request) {
            this.$snotify.error(`No response received.`, {
              timeout: 0,
              closeOnClick: true,
            });
          } else {
            this.$snotify.error(`${error.message}`, {
              timeout: 0,
              closeOnClick: true,
            });
          }
        });
    },

    selectRange(item) {
      if (!this.selectedRange) this.selectedRange = item;
      else if (this.selectedRange.Id == item.Id) this.selectedRange = null;
      else this.selectedRange = item;
    },

    bulkDelete() {
      document
        .getElementById('BillBulkDelete')
        .setAttribute('redirected', 'viewAllBills');
      $('#viewAllBills').modal('hide');

      this.$store.commit(
        'updateSelectedBillsforBulkDelete',
        this.selectedbills
      );
    },

    // NOTE: Change to use moment
    last30Days: function() {
      this.endDate = Date.now(); // Using Date.now() as it's easier to mock
      this.startDate = new Date().setTime(this.endDate - 3600 * 1000 * 24 * 30);
    },
    last6Months: function() {
      this.endDate = Date.now();
      this.startDate = new Date().setTime(
        this.endDate - 3600 * 1000 * 24 * 180
      );
    },
    last12Months: function() {
      this.endDate = Date.now();
      this.startDate = new Date().setTime(
        this.endDate - 3600 * 1000 * 24 * 365
      );
    },
    clearFilter: function() {
      this.startDate = null;
      this.endDate = null;
    },
    saveChanges(statement) {
      this.submitStatus = 'PENDING';
      this.$http
        .put(
          'https://' +
            Vue.config.honeycomb.billbot.domain +
            '/api/v1/OnHold/set',
          {
            StatementId: statement.Id,
            StatusNarrative: statement.StatusNarrative,
          },
          {
            withCredentials: true,
          }
        )
        .then(() => {
          this.submitStatus = 'OK';
          this.editMode = false;
          this.$snotify.success(`Success! On hold reason(s) updated.`);
          this.$store.dispatch('getOHReport');
        })
        .catch((error) => {
          // Error
          this.submitStatus = 'ERROR';
          Object.assign(statement, this.beforeEditingNarrative);
          this.editMode = false;
          if (error.response) {
            // The request was made and the server responded with a status code
            // that falls out of the range of 2xx
            if (error.response.data.MoreInformation.length > 0) {
              error.response.data.MoreInformation.forEach((e) => {
                this.$snotify.error(`${e.Error}`, {
                  timeout: 0,
                  closeOnClick: true,
                });
              });
            } else {
              this.$snotify.error(`${error.response.data.UserDescription}`, {
                timeout: 0,
                closeOnClick: true,
              });
            }
          } else if (error.request) {
            // The request was made but no response was received
            // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
            // http.ClientRequest in node.js
            this.$snotify.error(`No response received.`, {
              timeout: 0,
              closeOnClick: true,
            });
          } else {
            // Something happened in setting up the request that triggered an Error
            this.$snotify.error(`${error.message}`, {
              timeout: 0,
              closeOnClick: true,
            });
          }
        });
    },
    release(item) {
      setTimeout(() => {
        this.$http
          .put(
            'https://' +
              Vue.config.honeycomb.billbot.domain +
              '/api/v1/OnHold/release/' +
              item.Id,
            {
              BillIds: [item.Id],
            },
            {
              withCredentials: true,
            }
          )
          .then(() => {
            this.submitStatus = 'OK';
            this.$snotify.success(`Success! Bill released.`);
            this.$store.dispatch('getBills');
            this.$store.dispatch('getLedger');
            this.$store.dispatch('getCharges');
            this.$store.dispatch('getUsage');
            this.$store.dispatch('refreshReadings');
          })
          .catch((error) => {
            // Error
            if (error.response) {
              // The request was made and the server responded with a status code
              // that falls out of the range of 2xx
              this.submitStatus = 'Error';
              if (error.response.data.MoreInformation.length > 0) {
                error.response.data.MoreInformation.forEach((e) => {
                  this.$snotify.error(`${e.Error}`, {
                    timeout: 0,
                    closeOnClick: true,
                  });
                });
              } else {
                this.$snotify.error(`${error.response.data.UserDescription}`, {
                  timeout: 0,
                  closeOnClick: true,
                });
              }
            } else if (error.request) {
              // The request was made but no response was received
              // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
              // http.ClientRequest in node.js
              this.submitStatus = 'Error';
              this.$snotify.error(`No response received.`, {
                timeout: 0,
                closeOnClick: true,
              });
            } else {
              // Something happened in setting up the request that triggered an Error
              this.submitStatus = 'Error';
              this.$snotify.error(`${error.message}`, {
                timeout: 0,
                closeOnClick: true,
              });
            }
          });
      }, 1200);
    },
    // hold(statement) {
    //   setTimeout(() => {
    //     this.$http
    //       .put(
    //         "https://" +
    //           Vue.config.honeycomb.billbot.domain +
    //           "/api/v1/OnHold/set/" +
    //           statement.Id,
    //         {
    //           BillIds: [statement.Id]
    //         },
    //         {
    //           withCredentials: true
    //         }
    //       )
    //       .then(() => {
    //         this.submitStatus = "OK";
    //         this.$snotify.success(`Success! Bill placed on hold.`);
    //         this.$store.dispatch("getBills");
    //         this.$store.dispatch("getLedger");
    //         this.$store.dispatch("getCharges");
    //         this.$store.dispatch("getUsage");
    //         this.$store.dispatch("refreshReadings");
    //       })
    //       .catch(error => {
    //         // Error
    //         if (error.response) {
    //           // The request was made and the server responded with a status code
    //           // that falls out of the range of 2xx
    //           this.submitStatus = "Error";
    //           if (error.response.data.MoreInformation.length > 0) {
    //             error.response.data.MoreInformation.forEach(e => {
    //               this.$snotify.error(`${e.Error}`);
    //             });
    //           } else {
    //             this.$snotify.error(`${error.response.data.UserDescription}`);
    //           }
    //         } else if (error.request) {
    //           // The request was made but no response was received
    //           // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
    //           // http.ClientRequest in node.js
    //           this.submitStatus = "Error";
    //           this.$snotify.error(`No response received.`);
    //         } else {
    //           // Something happened in setting up the request that triggered an Error
    //           this.submitStatus = "Error";
    //           this.$snotify.error(`${error.message}`);
    //         }
    //       });
    //   }, 1200);
    // }
  },
};
</script>
